import { RoleTaskNotifications } from "./RoleTaskNotifications";

/**
 * Alerts publishers whenever a new task lands in "Ready to be Published".
 * Backward-compatible wrapper around the generic RoleTaskNotifications.
 */
export function PublisherNotifications() {
  return (
    <RoleTaskNotifications
      role="publisher"
      targetStatus="checked"
      accent="#F472B6"
      label="Ready to be Published"
    />
  );
}
